import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import withSizes from 'react-sizes';
import { Row, Col } from 'deltoid/core/Blocks/BootstrapContainers';
import { Caption } from 'deltoid/core/Blocks/Typography';
import Form from 'deltoid/core/Form';

import Dialog from '@components/ServiceAgreement/Dialog';
import { dialogActions, merchantSelectors, serviceAgreementActions, serviceAgreementSelectors } from '@store/ducks';

const ServiceAgreement = ({
  closeDialog,
  isDesktop,
  isTab,
  getIsServiceAgreementEsigned,
  fetchServiceAgreement,
  msaProcessing,
  getEsignedAgreement,
  getEsignedAgreementProcessing,
}) => {
  const [state, setState] = useState({});
  useEffect(() => {
    updateContent()
  }, []);

  useEffect(() => {
    updateContent()
  }, [getIsServiceAgreementEsigned])

  const updateContent = () => {
    let content = {};
    if (!getIsServiceAgreementEsigned) {
      content = {
        title: 'By clicking on “Review and e Sign” you will receive an OTP on your registered email id. Entering the OTP will be equivalent to signing the agreement.',
        btnLabel: 'Review and e-sign'
      };
    } else {
      content = {
        title: "You have already signed your agreement. Click on the 'View Agreement' button to see a digitally signed copy of your agreement.",
        btnLabel: 'View Signed Agreement'
      };
    };
    setState(content);
  }
  return (
    <div className='p-4'>
      <Row>
        <Col md={isDesktop ? 8 : 9}>
          <Caption>{state.title}</Caption>
        </Col>
        <Col md={isDesktop ? 4 : 3} className='my-auto text-right'>
          <Form.Button
            type='button'
            className={isTab ? 'mt-2' : 'w-100'}
            onClick={() => {
              if (getIsServiceAgreementEsigned) {
                getEsignedAgreement();
              } else {
                fetchServiceAgreement();
              }
            }}
            disabled={msaProcessing || getEsignedAgreementProcessing}
            loading={msaProcessing || getEsignedAgreementProcessing}
          >
            {state.btnLabel}
          </Form.Button>
        </Col>
      </Row>
      <Dialog onClose={closeDialog}/>
    </div>
  )
};

const mapSizesToProps = ({ width }) => ({
  isDesktop: width < 992,
  isTab: width < 768,
});

const Responsive = withSizes(mapSizesToProps)(ServiceAgreement);

const mapStateToProps = (state) => ({
  getIsServiceAgreementEsigned: merchantSelectors.getIsServiceAgreementEsigned(state),
  msaProcessing : serviceAgreementSelectors.msaProcessing(state),
  getEsignedAgreementProcessing: serviceAgreementSelectors.getEsignedAgreementProcessing(state),
})

const mapDispatchToProps = dispatch => ({
  closeDialog: () => dispatch(dialogActions.close()),
  fetchServiceAgreement: () => dispatch(serviceAgreementActions.fetch()),
  getEsignedAgreement: () => dispatch(serviceAgreementActions.getEsignedAgreement()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Responsive);
